import React from 'react'
import logo from '../../assets/Images/logo.png'

function Header({heading}) {
    return (
        <div className="logo_text_main_div">
        <div className='logo_div'>
            <img src={logo} className='img_logo' />
        </div>
        <div className="text_div">
            <div className="inner_text_div">
                    <h1>{heading}</h1>
                <p>Obtenez en quelques clics une estimationt de la rentablité de votre installation</p>
            </div>
        </div>
    </div>
    )
}

export default Header
